import { cn } from 'cn';
import { useTranslation } from 'react-i18next';
import LogoDark from '#/assets/logo.svg?react';
import LogoLight from '#/assets/logo-darkmode.svg?react';

export function Logo({
  className,
  mode = 'dark',
}: {
  className?: string;
  mode?: 'dark' | 'light';
}) {
  const { t } = useTranslation();
  const title = t('app.title');

  return (
    <figure className="text-white">
      <a
        href="/"
        className={cn(
          'flex items-center justify-center rounded-md py-2 px-4',
          className,
        )}
      >
        {mode === 'dark' ? (
          <LogoLight
            aria-label={t('app.title')}
            data-testid="logo"
            className="h-6 w-40"
          />
        ) : (
          <LogoDark
            aria-label={t('app.title')}
            data-testid="logo"
            className="h-6 w-40"
          />
        )}
      </a>
      <figcaption className="ml-3 hidden">{title}</figcaption>
    </figure>
  );
}
